
/** Maps a semantic tone to the active theme's colour (works for every light/dark palette). */
export function toneColor(theme, tone) {
  return tone === 'neutral' ? theme.palette.text.secondary : theme.palette[tone].main;
}
